import React from 'react'
import Sketch from 'react-p5'

import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

let strings = new LocalizedStrings({
    en:{
        title:"grow",
        description:""
    },
    de: {
        title:"wachsen",
        description:""
    }
});

function HugeChar() {
}

HugeChar.prototype.initialise = function(p5) {
  this.angle = 0;
  this.angleInc = p5.random(-0.1, 0.1);

  this.size = 100;
  this.sizeInc = p5.random(-1, 1);

  this.x = p5.width/2;
  this.xInc = p5.random(-2, 2);

  this.y = p5.height/2;
  this.yInc = p5.random(-2, 2);

  this.ch = p5.random(["X", "Y", "Z"]);

  this.isRed = p5.random([true, false]);

  this.p5 = p5;
};

HugeChar.prototype.draw = function() {
  this.p5.push();
  this.p5.textSize(this.size);
  this.p5.translate(this.x, this.y);
  this.p5.rotate(this.angle);
  this.p5.noFill();
  if (this.isRed) {
      this.p5.stroke(255, 0, 0, 100);
  }
  else {
      this.p5.stroke(255, 255, 255, 100);
  }
  this.p5.text(this.ch, 0, 0);
  this.p5.pop();
};

HugeChar.prototype.step = function() {
  this.x += this.xInc;
  this.y += this.yInc;
  this.size += this.sizeInc;
  this.angle += this.angleInc;
};

class Huge extends React.Component {
    constructor(props) {
        super(props)

        this.charCount = 4;
        this.chars = [];

        this.reset = this.reset.bind(this)
        this.setup = this.setup.bind(this)
        this.draw = this.draw.bind(this)
        this.windowResized = this.windowResized.bind(this)
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)
    }

    reset(p5) {
        p5.background(0);

        p5.textFont("DejaVuSerif");

        this.charCount = p5.random(3, 7);

        for (var i = 0; i < this.charCount; i++) {
          var ch = new HugeChar();
          ch.initialise(p5);

          this.chars.push(ch);
        }
    }

    setup(p5, canvasParentRef) {
        p5.createCanvas(window.innerWidth, window.innerHeight).parent(canvasParentRef)

        this.reset(p5)
    }

    draw(p5) {
        for (var i = 0; i < this.chars.length; i++) {
            this.chars[i].draw();
            this.chars[i].step();
        }
    }

    windowResized(p5) {
        p5.resizeCanvas(window.innerWidth, window.innerHeight)

        this.reset(p5)
    }

    render() {
        strings.setLanguage(this.context.language)
        return <Sketch setup={this.setup} draw={this.draw} windowResized={this.windowResized} />
    }
}
Huge.contextType = LanguageContext

export default Huge
